'use client';
import { LeftSidebar } from '@wwe-portal/ui/layout/app';

import Image from 'next/image';
import {
  PlayGameButton,
  StickyPlayGameButtonDesktopOnly,
} from './sticky-playgame-button';
import Link from 'next/link';
import { BackToGameLink } from './back-to-game-button';
import { WebsiteSubtitle } from '@wwe-portal/ui/layout/app/left-sidebar/logo-menu';
import { APP_STORE_URL, GOOGLE_PLAY_URL } from '@wwe-portal/web/utils/config';
import { reloadOTBanner } from '../../external/ot-banner-initiator';
import { SOCIAL_LINKS_MENU } from '../../../utils/constants/pages';
import { sendStoreClickEvent } from '@wwe-portal/web/libs/analytics/side-bar';
import { LEFT_SIDEBAR_ID } from '@wwe-portal/web/utils/constants/keys';
import { CloseSidebarButton } from '@wwe-portal/ui/layout/app/left-sidebar/close-sidebar-button';
import { useLayoutStore } from '@wwe-portal/web/providers/stores/layout-store';
import { OddsLink } from './odds-link';

export const LeftSidebarContent = ({
  menu,
  className,
}: {
  menu: React.ReactNode;
  className?: string;
}) => {
  const setSidebar = useLayoutStore((state) => state.setSidebar);
  return (
    <LeftSidebar
      className={className}
      websiteSubtitle={
        <BackToGameLink fallback={<WebsiteSubtitle />}>
          <div className="text-blue700 text-sm font-medium">Back to game</div>
        </BackToGameLink>
      }
      playGameContent={<StickyPlayGameButtonDesktopOnly />}
      mobilePlayGameContent={<PlayGameButton />}
      websiteName={
        <Link href="/">
          <div className="text-text300 hover:text-green800 text-xs font-semibold xl:text-xs">
            WWE Champions
          </div>
        </Link>
      }
      logo={
        <Link href="/">
          <Image
            alt="wwe champions"
            fill
            src="/assets/images/common/wwe-logo.webp"
          />
        </Link>
      }
      // FORUM BUTTON HIDDEN
      // forumButton={
      //   <div className="py-6">
      //     <ForumButton
      //       textClassName="text-xs"
      //       icon={
      //         <Image
      //           alt="logo"
      //           className="max-w-[26px]"
      //           draggable="false"
      //           width={26}
      //           height={23}
      //           src="/assets/images/common/forum-logo.webp"
      //         />
      //       }
      //       onClick={() => sendForumBtnClickEvent(true)}
      //     />
      //   </div>
      // }
      menus={menu}
      socialLinks={SOCIAL_LINKS_MENU}
      reloadOTBanner={reloadOTBanner}
      googlePlay={
        <a
          href={GOOGLE_PLAY_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => sendStoreClickEvent('Left Sidebar', 'android')}
        >
          <Image
            src="/assets/images/common/google-play.svg"
            alt="google play"
            className="h-[40px] w-[120px] object-fill"
            width={120}
            height={40}
          />
        </a>
      }
      appStore={
        <a
          href={APP_STORE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => sendStoreClickEvent('Left Sidebar', 'ios')}
        >
          <Image
            src="/assets/images/common/app-store.svg"
            alt="apple play"
            className="h-[40px] w-[120px] object-fill"
            width={120}
            height={40}
          />
        </a>
      }
      id={LEFT_SIDEBAR_ID}
      oddsLink={
        <OddsLink
          className="text-text600 hover:text-green700 hover:no-underline"
          dataId="left_sidebar_odds_link"
        />
      }
      closeSidebarButton={
        <CloseSidebarButton onClick={() => setSidebar('none')} />
      }
    />
  );
};
